<template>
    <transition name="fade">
        <div class="popup_wrpr app_settings_popup_wrpr active" @click.self="closePopup">
            <div class="app_settings_popup" :class="{right_open: panel}">
                <div class="popup_left_side">
                    <a class="close_popup_btn" @click.prevent="closePopup">
	                    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
                    </a>

<!--                    <a class="right_toggle" :class="{active: panel}" @click.prevent="$emit('togglePanel')">-->
<!--	                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--		                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.96124 8.03874L6.37208 8.6279L2.74416 4.99999L6.37208 1.37207L6.96124 1.96124L3.92249 4.99999L6.96124 8.03874Z" fill="#E4E6F1"></path>-->
<!--	                    </svg>-->
<!--                    </a>-->

                    <div class="popup_header">
                        <h3>{{title}}</h3>
                    </div>
                    <span v-if="subtitle" class="popup_subtitle" style="margin: 0 15px 20px;">{{subtitle}}</span>

                    <div class="popup_side_content funnel-app-settings">
                        <Loading v-show="loading"/>
                        <slot name="content"></slot>
                    </div>

                    <div class="bottom_btns_wrpr">
                        <slot name="actions"></slot>
                    </div>
                </div>

                <div class="popup_right_side">
                    <slot name="rightSide"></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import Loading from "@/components/Loading.vue"
    export default {
        name: "DetailsPopup",
        props:['title', 'subtitle', 'loading', 'panel'],
        components: { Loading },
        methods: {
            closePopup() {
                this.$emit("close");
            },
        }
    }
</script>

